package com.example.hukakmp.counter

import kotlinx.serialization.Serializable

@Serializable
data class FishCounterEntry(
    val name: String,
    val count: Int,
    val returned: Int = 0,
)

expect object FishCounterPersistence {
    fun load(): String?
    fun save(value: String)
    fun clear()
}
